import * as React from 'react';
import { Backdrop } from 'components/Backdrop/Backdrop';

type Props = {
  className?: string;
  title?: string;
  question?: string;
  onDelete: () => void;
};

const DeleteButton = ({ className, title, question, onDelete }: Props) => {
  const [asking, setAsking] = React.useState(false);

  const cancelAsking = () => setAsking(false);
  const beginAsking = () => setAsking(true);

  const deleteObject = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    cancelAsking();
    onDelete();
  };

  return (
    <>
      <button className={`tertiary delete-button ${className}`} onClick={beginAsking}>
        {title || 'löschen'}
      </button>
      {asking && (
        <dialog open>
          <Backdrop disableBackdrop={cancelAsking} />
          <div className="interstition shadow">
            <div className="question">{question || 'Wirklich löschen?'}</div>
            <div className="delete-buttons">
              <button className="tertiary" onClick={deleteObject}>
                Ja
              </button>
              <button className="primary" onClick={cancelAsking}>
                Nein
              </button>
            </div>
          </div>
        </dialog>
      )}
    </>
  );
};

export default DeleteButton;
